import(/* webpackMode: "eager", webpackExports: ["BlogPostList"] */ "/home/bdeh8989/dev.ecole-st-augustin.fr/v2/app/components/blog/blogpost-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/bdeh8989/dev.ecole-st-augustin.fr/v2/app/components/breadcrumb.tsx");
